import { useEffect, useState } from 'react'
import { api } from '../api.js'

// Le cœur de la promesse : une commune n'écrit pas ses formulaires, elle
// choisit dans une bibliothèque déjà rédigée et paramétrée.
export default function Bibliotheque({ orgId }) {
  const [liste, setListe] = useState([])
  const [partage, setPartage] = useState([])
  const [categorie, setCategorie] = useState('')
  const [q, setQ] = useState('')
  const [message, setMessage] = useState('')

  const charger = () => {
    api.catalog().then(setListe)
    api.shared(orgId).then(setPartage).catch(() => setPartage([]))
  }
  useEffect(() => { charger() }, [orgId])   // eslint-disable-line

  const categories = [...new Set(liste.map((d) => d.category))]
  const filtree = liste.filter((d) =>
    (!categorie || d.category === categorie) &&
    (!q || (d.title + d.description + d.category).toLowerCase().includes(q.toLowerCase())))

  async function installer(key, titre) {
    await api.install(key)
    setMessage(`« ${titre} » ajoutée. Mettez votre portail à jour pour la rendre visible.`)
    charger()
  }

  return (
    <>
      <h1>Ajouter des démarches</h1>
      <p className="chapo">Des démarches complètes, prêtes à recevoir des dossiers : le formulaire,
        le circuit de traitement et les courriels sont installés d'un bloc.</p>
      {message && <p className="succes" role="status">{message}</p>}

      {partage.filter((p) => !p.already).length > 0 && (
        <section className="carte">
          <h2>Proposé par {partage[0].from}</h2>
          <p className="aide">Vous en devenez propriétaire : vos modifications ne remontent pas,
            et vous décidez vous-même de reprendre ou non les évolutions futures.</p>
          <div className="grille">
            {partage.filter((p) => !p.already).map((p) => (
              <article className="fiche" key={p.key}>
                <p className="cat">{p.category}</p>
                <h3>{p.title}</h3>
                <p>{p.description}</p>
                <button className="btn pri sm" onClick={async () => {
                  await api.adopt(orgId, p.key); charger()
                }}>Reprendre cette démarche</button>
              </article>
            ))}
          </div>
        </section>
      )}

      <div className="barre">
        <div className="onglets">
          <button className={!categorie ? 'on' : ''} onClick={() => setCategorie('')}>Tout</button>
          {categories.map((c) => (
            <button key={c} className={categorie === c ? 'on' : ''} onClick={() => setCategorie(c)}>{c}</button>
          ))}
        </div>
        <input type="search" value={q} onChange={(e) => setQ(e.target.value)}
               placeholder="Rechercher" aria-label="Rechercher une démarche" />
      </div>

      <div className="grille">
        {filtree.map((d) => (
          <article className={`fiche ${d.installed ? 'installee' : ''}`} key={d.key}>
            <p className="cat">{d.category}{d.featured && <span className="tag">très demandée</span>}</p>
            <h3>{d.title}</h3>
            <p>{d.description}</p>
            <p className="mono petit">{d.questions} questions</p>
            {d.installed
              ? <span className="ok">installée</span>
              : <button className="btn pri sm" onClick={() => installer(d.key, d.title)}>
                  Ajouter à mon portail
                </button>}
          </article>
        ))}
      </div>
    </>
  )
}
